import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuditoriaAutoComponent } from '../auditoria-auto/auditoria-auto.component';
import { ResultadosAudiComponent,DialogCrearMuestra } from '../auditoria-auto/resultados-audi/resultados-audi.component';
import { ResultadosAudiModule } from '../auditoria-auto/resultados-audi/resultados-audi.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { AuthAdminGuard } from 'app/auth/auth-admin.guard';
import {MatTableModule} from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import { MatInputModule } from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatSortModule} from '@angular/material/sort';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSelectModule} from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { ChartsModule } from 'ng2-charts';
import { FormsModule } from '@angular/forms';
const rutas: Routes = [
    // trust index
    {
        path     : 'auditoria/auditoriaAutomatizada',
        component: AuditoriaAutoComponent,
        canActivate: [AuthGuard, AuthAdminGuard],
      },
    {
        path: 'auditoria/auditoriaAutomatizada/resultados-audi',
        component: ResultadosAudiComponent,
        canActivate: [AuthGuard, AuthAdminGuard]
    },


];
@NgModule({
  declarations: [AuditoriaAutoComponent,ResultadosAudiComponent,DialogCrearMuestra],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    MatTableModule,
    FlexLayoutModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatIconModule,
    MatSortModule,
    MatProgressSpinnerModule,
    ResultadosAudiModule,
    MatSelectModule,
    MatTabsModule,
    ChartsModule,
    FormsModule

  ],
  entryComponents:[
  DialogCrearMuestra,
    ],
})
export class AuditoriaAutoModule { }
